import { render, staticRenderFns } from "./LxDatepicker.vue?vue&type=template&id=bcf61966&scoped=true"
import script from "./LxDatepicker.vue?vue&type=script&lang=js"
export * from "./LxDatepicker.vue?vue&type=script&lang=js"
import style0 from "./LxDatepicker.vue?vue&type=style&index=0&id=bcf61966&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf61966",
  null
  
)

export default component.exports